module.exports = __webpack_public_path__ + "assets/img/upload-preview.e8687416.png";